import React, { Component } from 'react';
import { Container, Accordion, Icon } from 'semantic-ui-react';
import { PtSelect } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';
import '../../../index.css';
import config from '../../../config.json';

export default class LoadLimits extends Component {
    constructor(props) {
        super(props);
        const { ownModel } = this.props;
        this.options = []
        this.state = ownModel.loadLimits;
    }

    render() {
        const { loadLimitOptions,
                grossWeightOptions} = DropdownLib.getDropdowns().OL_LoadLimits;
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title" onClick={this.getZoneOptions}>
                            <Icon name='dropdown' />
                            Seasonal (spring)
                        </Accordion.Title>
                        <Accordion.Content>
                            <PtSelect label="Load Limit" options={loadLimitOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                                defaultVal={this.state.seasonalLoadLimit} name="seasonalLoadLimit" />
                            <PtSelect label="Gross Weight" options={grossWeightOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                                defaultVal={this.state.seasonalGrossWeight} name="seasonalGrossWeight" />
                            <PtSelect label="Assigned Zone"  options={this.options} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                                            defaultVal={this.state.assignedZone} name="assignedZone"/>
                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Year Round
                        </Accordion.Title>
                        <Accordion.Content>
                            <PtSelect label="Load Limit" options={loadLimitOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                                defaultVal={this.state.yearRoundLoadLimit} name="yearRoundLoadLimit" />
                            <PtSelect label="Gross Weight" options={grossWeightOptions} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                                defaultVal={this.state.yearRoundGrossWeight} name="yearRoundGrossWeight" />
                        </Accordion.Content>
                    </Accordion>

                </ScrollArea>
            </Container>
        );
    }

    getZoneOptions = async () =>{
        const zoneOptions = []
        const keys = []
        await fetch(`${config.server}/assignzoneOptions/`+this.props.ownModel.agencyId)
        .then(response=>
            {
                return response.json();
            })
        .then(data=>{
            for (var i =0;i<data[0].length;i++){
                if (data[0][i]['Zone_key']!==998){
                zoneOptions.push(data[0][i]['description'])
                keys.push(data[0][i]['Zone_key'])
                }
            }
            let dropOptions = zoneOptions.map((option,idx)=>{
            return {key:keys[idx],value: keys[idx], label:option, isSelected:false}
           });   
            this.options = dropOptions;
            this.forceUpdate(); 
             
        })
        .catch(error=>{
            console.log(error);
        });
    
    }
   
    onChangeDropdown = (e) => {
        const { target } = e;
        const {name, value} = target;

        this.props.triggerNeedSave();
        this.setState({ [name]: parseInt(value) });
    }

    componentDidMount () {
        this.getZoneOptions();
    }
   
    componentDidUpdate() {
        this.props.ownModel.loadLimits = this.state;
      }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/owner-load-limits/load-limits.js